import React from "react";
import Mainimage from "../media/1.jpg";
import "./Main.scss";

function Main() {
  return (
    <div>
      <div id="main-image">
        <img src={Mainimage} width={"300px"}></img>
      </div>
      <ul>
        <li>이름: 박서정</li>
        <li>생년월일: 1999년 10월 13일</li>
      </ul>
    </div>
  );
}

export default Main;
